import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import React from 'react';

var DividerRoot = styled(Divider)(function (_a) {
    var theme = _a.theme;
    var menu = theme.componentsConfig.menu;
    return {
        marginRight: -menu.paddingX,
        marginLeft: -menu.paddingX,
    };
});
var MenuDivider = React.forwardRef(function MenuDivider(props, ref) {
    return React.createElement(DividerRoot, { component: "li", ref: ref });
});

export { MenuDivider as default };
